module.exports = __webpack_public_path__ + "img/38.71ee80b9.webp";